module.exports = __webpack_public_path__ + "img/6-1.f3c29349.jpg";